module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "fmtitle1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_vm._v("Contents")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Acknowledgement"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Part01"
    }
  }, [_c('i', [_vm._v("Gateway to the West")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter01"
    }
  }, [_vm._v("Growing")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter02"
    }
  }, [_vm._v("Newcomers in a Troubled Land")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter03"
    }
  }, [_vm._v("The Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commerce")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three Pokes of a Thistle")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thank You in Arabic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("World Gifts")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One Village")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Local Hospitality")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grazing")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roses for Lubbock")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Camel Like Only Camel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Lucky People")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rattle of Wheels toward the Rooms of the New Mothers")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nineties")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_x",
      "title": "x"
    }
  }, [_vm._v("David Crockett’s Other Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Favorite Cleaners, San Antonio")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Enigma")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Life with Medicine")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Speaking Arabic")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maintenance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Troubled Land")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tulips")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pablo Tamayo")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The World and All Its Teeth")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marie")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Keys")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomorrow We Smile")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Field Trip")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Neighborhood Quartet in a Minor Key")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Home Address")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monumental")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Broken Clock")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Part05",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Still the Sky")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/46_Chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poetry")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/47_Chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banned Poem")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/48_Chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Women of the West")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/49_Chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Used Cars on Oahu")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/50_Chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mint Snowball")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/51_Chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("White Coals")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/52_Chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Talk, Talk, Talk")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/53_Chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One Moment on Top of the Earth")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b863104","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Contents.vue
// module id = 78
// module chunks = 0